import { Routes } from '@angular/router';

import { stationInfoGuard } from './shared/guards/can-activate-station-info.guard';

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
  },
  {
    path: 'chargePort/:id',
    loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
  },
  {
    path: 'cookiesAndPixel',
    loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
  },
  {
    path: 'prepare-payment/:id',
    pathMatch: 'full',
    loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
    canActivate: [stationInfoGuard],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
